import React, { useState, useEffect } from "react";
import { Col, Stack } from 'react-bootstrap';
import { VALIDATION } from '../commonValidations';
import jwt from 'jwt-decode';
import { getLocalStorageItem } from "../localStorageUtils";
import { handleNumberFieldFocus } from "../commonFunction";

export const LocationPoint = (props) => {

    const [details, setDetails] = useState({
        Latitude: props.latitude ? props.latitude : '',
        Longitude: props.longitude ? props.longitude : '',
    })
    const [errorMessage, setErrorMessage] = useState({
        latitudesError: props.latitudesError,
        longitudesError: props.longitudesError,
    });
    const [urn, setUrn] = useState();

    useEffect(() => {
        if (getLocalStorageItem('id_token')) {
            const decoded = jwt(getLocalStorageItem('id_token'));
            const decoded_urn = decoded.extension_URN
            setUrn(decoded_urn);
        }
    }, [getLocalStorageItem('id_token')]);

    useEffect(() => {
        if (props.latitudesError)
            setErrorMessage({ latitudesError: props.latitudesError })
    }, [props.latitudesError]);

    useEffect(() => {
        if (props.longitudesError)
            setErrorMessage({ longitudesError: props.longitudesError })
    }, [props.longitudesError]);

    const showPosition = (position) => {
        setDetails({
            ...details,
            Latitude: position.coords.latitude,
            Longitude: position.coords.longitude
        })
        props.callBackLocation(position);
    }

    const getLocation = (e) => {
        e.preventDefault();
        if (navigator.geolocation) {
            setErrorMessage({ latitudesError: "" })
            setErrorMessage({ latitudesError: "" })
            navigator.geolocation.getCurrentPosition(showPosition);
        }
    }

    const handleChange = (e) => {
        e.preventDefault();
        if (e.target.name === props.latitudeName) {
            const limit = 18;
            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            props.callBackLocation({...details, [e.target.name]: e.target.value.slice(0, limit)});

            if ((e.target.value).length > 0 && VALIDATION.latitudeLongitudeValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, latitudesError: "" })

                setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })


            } else {
                setErrorMessage({ ...errorMessage, latitudesError: "Please enter valid latitude" })

            }

        }
        if (e.target.name === props.longitudeName) {
            const limit = 18;

            setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })
            props.callBackLocation({...details,[e.target.name]: e.target.value.slice(0, limit) });

            if ((e.target.value).length > 0 && VALIDATION.latitudeLongitudeValidation(e.target.value)) {
                setErrorMessage({ ...errorMessage, longitudesError: " " })
                setDetails({ ...details, [e.target.name]: e.target.value.slice(0, limit) })

            } else {
                setErrorMessage({ ...errorMessage, longitudesError: "Please enter valid longitude" })

            }

        }
        // if (!props.latitude) {
        //     setErrorMessage({ latitudesError: "Please enter latitude" })
        //     return false;
        // }
        // if (!props.longitude) {
        //     setErrorMessage({ longitudesError: "Please enter longitude" })
        //     return false;
        // }
    };

    return (
        <>
            <Col xs={12} md={12}>
                <div>
                    {urn == null ?
                        <Stack direction='horizontal' gap={1}>
                            <Col xs={6} md={6}>
                                <div className="label_grower_reg">{props.latitudeLabel}<span className="mandatory_field">*</span></div>
                                <input className='loginTexFields' type="number" onFocus={handleNumberFieldFocus} placeholder='Latitude' name={props.latitudeName} value={props.latitude ? props.latitude : details?.Latitude}
                                 style={{ background: props?.isDisabled && props?.isResource && "#ededed" }}   onChange={(e) => handleChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} disabled={props.isDisabled} />
                                <div className='errorText_lle1'>{errorMessage.latitudesError}</div>
                            </Col>
                            <Col xs={6} md={6}>
                                <div className="label_grower_reg">{props.longitudeLabel}<span className="mandatory_field">*</span></div>
                                <input className='loginTexFields' type="number" onFocus={handleNumberFieldFocus} name={props.longitudeName} placeholder='Longitude' value={props.longitude ? props.longitude : details?.Longitude}
                                 style={{ background: props?.isDisabled && props?.isResource && "#ededed" }}   onChange={(e) => handleChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}  disabled={props.isDisabled}/>
                                <div className='errorText_lle1'>{errorMessage.longitudesError}</div>
                            </Col>
                        </Stack>

                        :
                        <Stack direction='horizontal' gap={1}>
                            <Col xs={6} md={6}>
                                <div className="label_grower_reg">{props.latitudeLabel}</div>
                                <input className='loginTexFields' type="number" onFocus={handleNumberFieldFocus} placeholder='Latitude' name={props.latitudeName} value={props.latitude ? props.latitude : details.Latitude}
                               style={{ background: props?.isDisabled && props?.isResource && "#ededed" }} onChange={(e) => handleChange(e)} onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} disabled={props.isDisabled} />
                                <div className='errorText_lle1'>{errorMessage.latitudesError}</div>

                            </Col>
                            <Col xs={6} md={6}>
                                <div className="label_grower_reg">{props.longitudeLabel}</div>
                                <input className='loginTexFields' type="number" onFocus={handleNumberFieldFocus} name={props.longitudeName} placeholder='Longitude' value={props.longitude ? props.longitude : details.Longitude}
                               style={{ background: props?.isDisabled && props?.isResource && "#ededed" }} onChange={(e) => handleChange(e)}  onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()} disabled={props.isDisabled} />
                            <div className='errorText_lle1'>{errorMessage.longitudesError}</div>
                            </Col>
                        </Stack>
                    }
                </div>
                <input className="edittextGetLocation" type="submit" value="Get Location" onClick={(e) => getLocation(e)} disabled={props.isDisabled} />
            </Col>
        </>
    )
}